// extracted by mini-css-extract-plugin
export default {"filterContainer":"TagFilter_filterContainer__WMOji","filterLabel":"TagFilter_filterLabel__MAqmJ","filterInput":"TagFilter_filterInput__O+JDL","clearBtn":"TagFilter_clearBtn__I3uLb"};